/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
import React, { createContext, useContext, useState } from "react";

export const ProgressContext: React.Context<any> = createContext(null);
export const ProgressProvider = ({ children }: any) => {
  const [inProgress, setInProgress] = useState<boolean>(false);

  return (
    <ProgressContext.Provider value={{ inProgress, setInProgress }}>
      {children}
    </ProgressContext.Provider>
  );
};

export const useProgressValue = () => useContext(ProgressContext);
